import { render, staticRenderFns } from "./ThgPayoutConfiguration.vue?vue&type=template&id=4328a789&scoped=true"
import script from "./ThgPayoutConfiguration.vue?vue&type=script&lang=ts"
export * from "./ThgPayoutConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./ThgPayoutConfiguration.vue?vue&type=style&index=0&id=4328a789&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4328a789",
  null
  
)

export default component.exports